
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menuItem",
      function () {
        return require("private-next-pages/menuItem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menuItem"])
      });
    }
  